import { ClientesSinContacto, EstadisticasCRM, EstadoProductosAnual, ResumenAtencion } from "../../bussines/entities/EstadisticasCRM.entity";
import { FechaParams } from "../../utils/params/FechaParams.params";
import { EstadisticasCRMDtSource } from "../../bussines/dataSources/EstadisticasCRMDtSource";
import { Recurso } from "lib.common/dist/CleanArch";
import { transformacion } from 'lib.common';
import { format } from "date-fns";
import { ErrExterno } from 'lib.common/dist/errorHandler';
import { appsUrlsApi } from "src/config/keys";

export class EstadisticasCRMDtSourceImplRest implements EstadisticasCRMDtSource {

    async getEstadisticasCRM(input: FechaParams): Promise<Recurso<EstadisticasCRM>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(appsUrlsApi.crm, '/monitor/estadisticasCRM');
            url.searchParams.append('fecha', fechaFormateada);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de estadisticas del CRM.');
            }

            const data: EstadisticasCRM = await response.json();
            return Recurso.fromData<EstadisticasCRM>(data);
        } catch (error) {
            return Recurso.fromError<EstadisticasCRM>(new ErrExterno(error as Error));
        }
    }

    async getClientesSinContacto(input: FechaParams): Promise<Recurso<ClientesSinContacto[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(appsUrlsApi.crm, '/monitor/clientesSinContacto');
            url.searchParams.append('fecha', fechaFormateada);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición de clientes sin contacto del CRM.');
            }

            const data: ClientesSinContacto[] = await response.json();
            return Recurso.fromData<ClientesSinContacto[]>(data);
        } catch (error) {
            return Recurso.fromError<ClientesSinContacto[]>(new ErrExterno(error as Error));
        }
    }

    async getResumenAtenciones(input: FechaParams): Promise<Recurso<ResumenAtencion[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(appsUrlsApi.crm, '/monitor/resumenAtenciones');
            url.searchParams.append('fecha', fechaFormateada);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición resumen atenciones del CRM.');
            }

            const data: ResumenAtencion[] = await response.json();
            return Recurso.fromData<ResumenAtencion[]>(data);
        } catch (error) {
            return Recurso.fromError<ResumenAtencion[]>(new ErrExterno(error as Error));
        }
    }

    async getProductosEstadoAnual(input: FechaParams): Promise<Recurso<EstadoProductosAnual[]>> {
        try {
            const fechaFormateada = format(input.fecha, 'yyyy-MM-dd');
            let url = transformacion.appendUrl(appsUrlsApi.crm, '/monitor/productosEstadoAnual');
            url.searchParams.append('fecha', fechaFormateada);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.message || 'Error en la petición productos estado anual del CRM.');
            }

            const data: EstadoProductosAnual[] = await response.json();
            return Recurso.fromData<EstadoProductosAnual[]>(data);
        } catch (error) {
            return Recurso.fromError<EstadoProductosAnual[]>(new ErrExterno(error as Error));
        }
    }
}